import { Box, Stepper, Step, StepButton } from '@mui/material'
import { type Model } from 'survey-core'

interface Props {
  surveyModel: Model
  currentPageIndex: number
  pageCompleteStatus: boolean[]
}

export function SurveyStepper ({ surveyModel, currentPageIndex, pageCompleteStatus }: Props): JSX.Element {
  const pageNames = surveyModel.pages.map(page => (page.title !== '' && page.title != null) ? page.title : page.name)

  if (pageNames.length <= 1) {
    return <></>
  }

  return (
    <Box sx={{ pl: '40px', maxWidth: '600px' }}>
      <Stepper activeStep={currentPageIndex} nonLinear>
        {pageNames.map((_label, index) => {
          const isComplete = pageCompleteStatus[index] ?? true
          return (
            <Step key={index} completed={isComplete}>
              <StepButton onClick={() => { surveyModel.currentPageNo = index }} />
            </Step>
          )
        })}
      </Stepper>
    </Box>
  )
}
